import React from 'react';

import Typography from '../../../Typography';
import { mergeOverrides } from '../../../utils';
import { BreadcrumbProps } from '../../types';
import Anchor from '../Anchor';
import { getDefaults } from './utils';

const Breadcrumb = ({ children, component, overrides, size = 'small', to }: BreadcrumbProps) => {
  const defaults = getDefaults({ size, to });
  const mergedOverrides = mergeOverrides(defaults, overrides);

  const LinkComponent = component ?? Anchor;

  if (to) {
    return (
      <LinkComponent className="" to={to}>
        <Typography variant="body-long-01" {...mergedOverrides.Typography}>
          {children}
        </Typography>
      </LinkComponent>
    );
  }
  return (
    <Typography variant="body-long-01" {...mergedOverrides.Typography}>
      {children}
    </Typography>
  );
};

export default Breadcrumb;
